import config from 'app/config'
import { useStores } from 'app/store'
import makeSiteGraphqlRequest from 'app/lib/graphql-request'

export default function useRequester() {
  const { userStore } = useStores()

  async function request<T>(
    query: string,
    variables?: any,
    formatFn?: (data: any) => T
  ) {
    if (!userStore) return

    try {
      return await makeSiteGraphqlRequest(config, query, variables, {
        userStore,
        formatFn,
      })
    } catch (e) {
      console.error(e)

      const error = e as any
      // handle graphql errors
      if (error.response?.errors) {
        throw new Error(error.response.errors[0].message)
      } else {
        throw e
      }
    }
  }

  return { request }
}
